import { render } from "./CardWhite.vue?vue&type=template&id=9b5c86a6&scoped=true"
import script from "./CardWhite.vue?vue&type=script&lang=js"
export * from "./CardWhite.vue?vue&type=script&lang=js"

import "./CardWhite.vue?vue&type=style&index=0&id=9b5c86a6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b5c86a6"]])

export default __exports__